import React, { useState, useEffect, useMemo } from "react";
import { Wallet } from "../../pages";
import { WalletController } from "../../controllers";
import { walletStore } from "../../stores";
import { toJS } from "mobx";
import { useNavigate } from "react-router-dom";

const WalletContainer = () => {
  const [loading, setLoading] = useState(false);
  const [currencyCode, setCurrencyCode] = useState("NGN");

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const walletTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}&currencyCode=${currencyCode}&type=Business`;
  }, [currentPage, currencyCode, limit]);

  const { isLoading, data, isFetching } = WalletController.useGetAllWallets(
    walletTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const setWallet = async () => {
      setLoading(true);
      await Promise.all([WalletController.getWalletBalance()]);
      setLoading(false);
    };
    setWallet();
  }, []);

  const goToSpecificWallet = (business) => {
    walletStore.setSelectedBusiness(business);
    navigate("/wallet-transactions");
  };

  return (
    <Wallet
      goToSpecificWallet={goToSpecificWallet}
      walletBalance={toJS(walletStore.walletBalance)}
      loading={loading}
      wallets={walletStore.wallets}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      currencyCode={currencyCode}
      setCurrencyCode={setCurrencyCode}
    />
  );
};
export default WalletContainer;
